module.exports = __webpack_public_path__ + "img/bitcoin.6640f6c9.png";